import request from '@/utils/ajax';

export function addMenu(data){
  return request({
    url: `/wx/sys/menu/save`,
    method: 'POST',
    data: data
  });
}

export function editMenu(data){
  return request({
    url: `/wx/sys/menu/update`,
    method: 'POST',
    data: data
  });
}

export function queryParentMenuList(){
  return request({
    url: `/wx/sys/menu/select`,
    method: 'get',
  });
}

export function queryMenuDetail(menuId){
  return request({
    url: `/wx/sys/menu/info/${menuId}`,
    method: 'get',
  });
}

export function deleteMenu(id){
  return request({
    url: `/wx/sys/menu/delete/${id}`,
    method: 'POST',
  });
}
export function queryMenu(){
  return request({
    url: '/wx/sys/menu/list',
    method: 'get',
  })
}

